import Mention from "@tiptap/extension-mention";
import type { SuggestionOptions } from "@tiptap/suggestion";

/**
 * Extended Mention node that uses data-mention-id / data-mention-name attributes,
 * matching the existing encodeMentionsFromHtml / decodeMentionsToHtml functions.
 *
 * Those functions expect: span.mention[data-mention-id][data-mention-name]
 */
const PulseMention = Mention.extend({
  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: (el) =>
          el.getAttribute("data-mention-id") || el.getAttribute("data-id"),
        renderHTML: (attrs) => {
          if (!attrs.id) return {};
          return { "data-mention-id": attrs.id };
        },
      },
      label: {
        default: null,
        parseHTML: (el) =>
          el.getAttribute("data-mention-name") || el.getAttribute("data-label"),
        renderHTML: (attrs) => {
          if (!attrs.label) return {};
          return { "data-mention-name": attrs.label };
        },
      },
    };
  },
  parseHTML() {
    return [
      { tag: "span.mention[data-mention-id]" },
      { tag: 'span[data-type="mention"]' },
    ];
  },
});

/**
 * Create a configured Mention extension for Pulse.
 */
export function createTiptapMention(
  suggestion: Omit<SuggestionOptions, "editor">,
) {
  return PulseMention.configure({
    HTMLAttributes: {
      class: "mention",
    },
    renderHTML({ node }) {
      return [
        "span",
        {
          class: "mention",
          "data-mention-id": node.attrs.id,
          "data-mention-name": node.attrs.label,
          contenteditable: "false",
        },
        `@${node.attrs.label ?? node.attrs.id}`,
      ];
    },
    renderText({ node }) {
      return `@${node.attrs.label ?? node.attrs.id}`;
    },
    suggestion,
  });
}
